import React from 'react'
import Form from 'antd/lib/form'
import Input from '@UI/antd/Input/Input'
import CharacterRecognitionFillIcon from 'remixicon-react/CharacterRecognitionFillIcon'
import { RemixiconReactIconComponentType } from 'remixicon-react/dist/typings'
import styles from './index.scss'

// rules can be including:
// 1- { whitespace: true }
// 2- { min: 3 }
// 3- { max: 10 }
// 4- { required: true, message: 'Please enter your name' }
interface IProps {
    label?: string
    name: string
    maxLength?: number
    showCount?: boolean
    minLength?: any
    height?: number
    maxHeight?: any
    required?: boolean
    requiredMsg?: string
    rules?: any
    onChange?: any
    hasFeedback?: boolean
    disabled?: boolean
    help?: string
    autoSize?: any
    defaultValue?: string
    Icon?: RemixiconReactIconComponentType | null
    readOnly?: boolean
    theme?: 'round-theme' | ''
    placeholder?: string
}

const TextareaField = (props: IProps) => {
    const {
        label,
        name,
        maxLength = 10000,
        showCount = true,
        minLength = null,
        height = 120,
        maxHeight = 'auto',
        required = false,
        requiredMsg = '',
        rules = [],
        onChange = undefined,
        hasFeedback = true,
        disabled = false,
        help = '',
        autoSize = {},
        Icon = null,
        defaultValue = '',
        readOnly = false,
        placeholder = '',
        theme = ''
    } = props
    const handleChange = e => {
        if (onChange) {
            onChange(e.target.value)
        }
    }

    const otherProps = defaultValue ? { defaultValue } : {}
    return (
        <>
            <style type="text/css">
                {`
                    .text-area-container-${name} textarea {
                        min-height: ${height}px !important;
                    }
                `}
            </style>
            <Form.Item noStyle shouldUpdate>
                {({ getFieldValue }) => (
                    <div className={`${styles['text-area-container']} ${styles[theme]} text-area-container-${name}`}>
                        <Form.Item
                            name={name}
                            rules={[
                                {
                                    required,
                                    message: requiredMsg || `Please enter your ${name}`
                                },
                                ...rules
                            ]}
                            style={{ marginBottom: help?.trim() ? 4 : 'auto' }}
                            hasFeedback={hasFeedback}
                        >
                            <Input.TextArea
                                showCount={!minLength && showCount}
                                maxLength={maxLength}
                                style={{ minHeight: height, height, maxHeight, resize: 'none' }}
                                label={label ? label + (required ? '*' : '') : ''}
                                onChange={handleChange}
                                disabled={disabled}
                                autoSize={autoSize}
                                readOnly={readOnly}
                                placeholder={placeholder || label}
                                {...otherProps}
                            />
                        </Form.Item>

                        <span className={styles['min-char-limitation']}>
                            {minLength && (
                                <>
                                    <span>
                                        {getFieldValue(name)?.length} characters (min {minLength} characters)
                                    </span>
                                    <CharacterRecognitionFillIcon size={18} />
                                </>
                            )}
                            {Icon && <Icon size={18} />}
                        </span>
                        {help.trim() && <div className={styles['help-text']}>{help.trim()}</div>}
                    </div>
                )}
            </Form.Item>
        </>
    )
}

export default TextareaField
